/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import cn from 'classnames';
import { getOriginByEnv } from 'core-lib/config/config';
import { useRouter } from 'next/router';
import { useState } from 'react';
import useWindowSize from 'core-lib/hooks/useWindowResize';
import { HeroType } from '../../types';
import s from './Hero.module.scss';

export const Hero = ({
  heroData,
  type = 'variant',
  clickCityPrice,
  isCityPrice,
  isPwa = false,
}: {
  heroData: HeroType;
  type: 'model' | 'variant';
  clickCityPrice?: () => void;
  isCityPrice?: boolean;
  isPwa?: boolean;
}) => {
  const [showColors, setShowColors] = useState<boolean>(false);
  const [carImage, setCarImage] = useState(heroData?.image);

  const router = useRouter();

  const { height, width } = useWindowSize();

  const toggleColors = () => {
    if (showColors) {
      setShowColors(false);
    } else {
      setShowColors(true);
    }
  };

  function handleColor(color: string, idx: number) {
    return color.toLowerCase().split('/')?.[idx];
  }

  function getShareLink() {
    if (type === 'model') {
      if (isPwa) {
        return `${getOriginByEnv()}/pwa/new-cars/${router?.query?.slug?.[0]}/${
          router?.query?.slug?.[1]
        }`;
      } else
        return `${getOriginByEnv()}/new-cars/${router?.query?.slug?.[0]}/${
          router?.query?.slug?.[1]
        }`;
    } else if (type === 'variant') {
      if (isPwa) {
        return `${getOriginByEnv()}/pwa/new-cars/${router?.query?.slug?.[0]}/${
          router?.query?.slug?.[1]
        }/${router?.query?.slug?.[2]}`;
      } else
        return `${getOriginByEnv()}/new-cars/${router?.query?.slug?.[0]}/${
          router?.query?.slug?.[1]
        }/${router?.query?.slug?.[2]}`;
    }
  }

  return (
    <div className={s.root}>
      <figure>
        { <img src={carImage} alt={`${heroData?.modelName}-image`} />}
      </figure>

      {heroData?.colors?.length > 0 && (
        <div className={s.colors_div}>
          <h3>Colors ({heroData?.colors?.length})</h3>
          <div
            className={cn(s.available_colors, {
              [s.showThreeColors]: !showColors,
              [s.showAllColors]: showColors,
            })}
          >
            {heroData?.colors?.map((item) => (
              <div
                className={s.colors}
                onClick={() => setCarImage(item?.image)}
                key={item?.color}
              >
                <div
                  className={s.color_circle}
                  style={
                    carImage === item?.image
                      ? { border: '1px solid $primaryColor' }
                      : {}
                  }
                >
                  {handleColor(item?.colorCode, 0) && (
                    <span
                      className={s.left}
                      style={{
                        backgroundColor: handleColor(item?.colorCode, 0),
                      }}
                    />
                  )}
                  {handleColor(item?.colorCode, 1) && (
                    <span
                      className={s.left}
                      style={{
                        backgroundColor: handleColor(item?.colorCode, 1),
                      }}
                    />
                  )}
                </div>
                <p className={s.color_name}> {item?.color}</p>
              </div>
            ))}
          </div>
          {(width < 768
            ? heroData?.colors?.length > 3
            : heroData?.colors?.length > 6) && (
            <div className={s.view_more}>
              <p onClick={() => toggleColors()}>
                {showColors ? 'View less' : `View more colors`}
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
